import type {ReactElement} from 'react';
import React from 'react';
import {BaseTextFillColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-text-fill-color-panel';
import type {RGBA} from '@Utils/color.util';
import type {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem';

export function TextslideFillColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const fillType = useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem('fillType');
  const fillColor = useGetKeyOfFillFromTextStylesOfSelectedTextSlideItem('fillColor');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID || !activeSlide) {
    throw new Error('unable to get the selected text slide');
  }

  if (!activeSlide.isTextSlide()) {
    throw new Error(`Expected text slide item but got ${activeItem?.gitype}`);
  }

  if (!fillColor || fillType === undefined) {
    throw new Error('unable to get fill properties for text slide');
  }

  const updateFillColor = (fillColor: RGBA[], undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        textStyles: {
          fill: {
            fillColor,
          },
        },
        list: {
          fill: {
            fillColor,
          },
        },
      },
      {undoable}
    );
    if (window.posterEditor?.whiteboard) {
      const color = fillColor[0];
      window.posterEditor.whiteboard.lastAddedTextColor = color;
    }
  };

  const onChangeType = (newType: FillTypes): void => {
    const fillObject = {
      fillType: newType,
      fillColor: activeSlide.textStyles.fill.getColorForNewType(newType),
    };
    void activeItem.updateSlideFromObject(activeSlideUID, {
      textStyles: {
        fill: {
          ...fillObject,
        },
      },
      list: {
        fill: {
          ...fillObject,
        },
      },
    });
  };
  return (
    <BaseTextFillColorPanel
      fillObject={{
        fillColor,
        fillType,
      }}
      onUpdateColor={updateFillColor}
      onChangeType={onChangeType}
    />
  );
}
